<template>
  <div class="relative">
    <input
      type="tel"
      v-mask="maskTokens"
      v-focus="AutoFocus"
      :placeholder="inputPlaceholder"
      v-model="phoneNumber"
      class="phone-input"
      :class="[widthClass, borderClass, heightClass, fontClass]"
      @input="getPhoneNumber"
    />
    <clear v-if="isClearable" class="clear-input" @click.native="clearInput" />
    <CountrySelector
      :options="countries"
      class="select-country"
      @selected="selectedCountry"
      :placeholder="$t('search')"
      :userCountryCode="userCountryCode"
      @changedCode="changedCodeHandler"
      :height="CountrySelectorHeight"
      :width="CountrySelectorWidth"
    />
  </div>
</template>

<script>
import Clear from '@/assets/icons/vue/close_normal.vue';
import focus from '@/directives/focus';
import axiosConfig from '@/services/axios.config';
import toastHandler from '@/utils/serverErrorsHandler';
import CountrySelector from '@/components/CountrySelector.vue';

export default {
  name: 'PhoneNumberInput',
  components: { CountrySelector, Clear },
  directives: {
    focus,
  },
  props: {
    isLogin: {
      type: Boolean,
      default: true,
    },
    AutoFocus: {
      type: Boolean,
      default: true,
    },
    inputValue: {
      type: String,
      default: '',
      required: false,
    },
    userCountryCode: {
      type: String,
      default: '',
    },
    width: {
      type: String,
      default: '318',
    },
    height: {
      type: String,
      default: '50',
    },
    CountrySelectorHeight: {
      type: String,
    },
    CountrySelectorWidth: {
      type: String,
    },
    radius: {
      type: String,
      default: 'sm',
    },
  },
  data() {
    return {
      countryCode: '',
      isClearable: false,
      isPhoneInvalid: false,
      maskTokens: {
        mask: '',
        tokens: {
          '*': {
            pattern: /[0-9]/,
          },
        },
      },
      phoneLength: 0,
      countries: [],
    };
  },
  computed: {
    phoneNumber: {
      get() {
        return this.inputValue;
      },
      set(value) {
        const phoneNum = value.replace(/\s/g, '');
        this.$emit('input', phoneNum);
        this.isClearable = !!this.phoneNumber;
      },
    },
    inputPlaceholder() {
      return this.maskTokens.mask.replaceAll('*', '-');
    },
    widthClass() {
      return `w-${this.width}`;
    },
    heightClass() {
      return `h-${this.height}`;
    },
    fontClass() {
      return this.CountrySelectorHeight ? 'text-sm' : 'font-semibold';
    },
    borderClass() {
      return {
        rounded: this.radius === 'default',

        'rounded-sm': this.radius === 'sm',

        'rounded-sm rounded-r-none': this.radius === 'sm-left',
      };
    },
  },
  mounted() {
    this.phoneNumber = this.inputValue;
    this.getPhoneNumber();
    this.getCountriesList();
  },
  methods: {
    getCountriesList() {
      axiosConfig
        .get('/countries')
        .then((response) => {
          this.countries = response.data.data;
        })
        .catch((error) => {
          toastHandler(error);
          throw error;
        });
      },
      getPhoneNumber(e) {
        if (e && e.target) {
          const phoneNum = e.target.value.replace(/\s/g, '');
          this.isPhoneInvalid = phoneNum.length !== this.phoneLength;
          this.$emit('isPhoneValid', this.isPhoneInvalid);
          if (this.isLogin) {
            this.$store.state.authentication.mobileNumber = phoneNum;
          }
        }
      },
      selectedCountry(e) {
        this.countryCode = e.code;
        this.maskTokens.mask = e.pattern;
        this.phoneLength = e.pattern.replace(/\s/g, '').length;
        this.$emit('countryCode', this.countryCode);
      },
      clearInput() {
        this.phoneNumber = '';
        if (this.isLogin) {
          this.$store.state.authentication.mobileNumber = '';
        }
      },
      changedCodeHandler(code) {
        this.$emit('changedCode', code);
      },
  },
};
</script>

<style scoped>

.phone-input {
  @apply  border border-default bg-secondary
    text-subtitle pl-102  focus:ring-0 focus:border-active;
  direction: ltr;
}
.select-country {
  @apply absolute top-4 left-4 z-10;
  direction: ltr;
}
.clear-input {
  @apply absolute top-20 right-12 hover:cursor-pointer;
}
</style>
